import React from "react";

export default function IDGuide({ userName }) {
    return (
        <div className="bg-slate-950 text-white rounded-xl border border-cyan-500 p-6">
            <h2 className="text-xl lg:text-2xl lfont-bold">
                🪪 Think5Whys ID Guide
            </h2>
            <p className="text-xs lg:text-sm text-slate-300 mb-6">
                Hi {userName}! Welcome to your Think5Whys Transformatioal Platform.
            </p>
            <div className="space-y-4">
                <div className="rounded-lg bg-slate-900 p-4">
                    <div className="text-sm lg:text-lg font-semibold">🚘 SnapID</div>
                    <div className="text-xs lg:text-sm text-slate-300">
                        Your brief and critical profile on Think5Whys.
                    </div>
                </div>
                <div className="rounded-lg bg-slate-900 p-4">
                    <div className="text-sm lg:text-lg font-semibold">💬 Talking ID Card</div>
                    <div className="text-xs lg:text-sm text-slate-300">
                        A utility Digital Card which speaks your infromation.
                    </div>
                </div>
            </div>

            <div className="mt-4 rounded-xl bg-gradient-to-r from-cyan-950/40 to-purple-950/40 border border-cyan-700 p-4 lg:p-6">
                <h3 className="text-sm lg:text-lg font-bold text-cyan-300 mb-4">
                    🧠 Why SnapID?
                </h3>
                <div className="rounded-lg bg-slate-900/70 p-3">
                    <ul className="list-disc list-inside space-y-1 text-gray-100 text-xs lg:text-sm">
                        <li className="text-gray-100 text-xs lg:text-sm">
                            For a compact and perfect short identity, complete this profile before proceeding further.
                        </li>
                        <li className="text-gray-100 text-xs lg:text-sm">
                            Find your unique 14-character <strong>Think5Whys Code</strong> to navigate and link multiple users and tasks.
                        </li>
                        <li className="text-gray-100 text-xs lg:text-sm">
                            Others can find and verify you using this 14-character Think5Whys Code. Simply long-press to copy and paste it into your IMs to share.
                        </li>
                        <li className="text-gray-100 text-xs lg:text-sm">
                            Your Country Code is the first level of authenticity and is required for transferring FuelStash credits, purchasing subscriptions, and other services.
                        </li>
                        <li className="text-gray-100 text-xs lg:text-sm">
                            Your State is essential for generating accurate Tax/GST invoices.
                        </li>
                        <li className="text-gray-100 text-xs lg:text-sm">
                            Area, City, and PIN/Postal Code help improve geographical search, visibility in Hustles, FindItLocal, and many other utilities.
                        </li>
                        <li className="text-gray-100 text-xs lg:text-sm">
                            Use <strong>Headline</strong> for your favorite quote, business display name, personal tagline, or the name of a loved one.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}